import { customSelect } from "./custom_select";

export class Yarn {
  constructor(count, container) {
    this.count = count;
    this.container = container;
    this.copyContainer = document.querySelector("#yarn-container-copy");
    this.hideDoubleThread = true;
    this.data = [];
  }

  template = (id) => {
    return `    <div class="w-40">
                    <span class="input-container__label">Material</span>
                    <input type="text" class="editor-form__input required editor-form__custom-select custom-material" autocomplete="off" data-type="yarn" name="yarn-no-material-${id}" id="yarn-no-material-${id}">
                    <div class="custom-select-list hidden"></div>
                </div>
                 <div class="w-30">
                    <span class="input-container__label">Type</span>
                    <input type="text" class="editor-form__input required editor-form__custom-select custom-type" autocomplete="off" data-type="yarn" name="yarn-no-${id}" id="yarn-no-${id}">
                    <div class="custom-select-list hidden"></div>
                </div>
                <div class="w-15">
                    <span class="input-container__label">No</span>
                    <input type="text" class="editor-form__input required custom-number" name="yarn-num-no-${id}" autocomplete="off" id="yarn-num-no-${id}" value="1.00">
                </div>
                <div class="editor-form__double-thread ${
                  this.hideDoubleThread ? "d-none" : ""
                } w-10">
                <span class="input-container__label">DBL</span>
                  <input type="text" class="editor-form__input" name="yarn-num-thread-${id}" autocomplete="off" id="yarn-num-thread-${id}">
                </div>
                <div class="w-25">
                    <span class="input-container__label">Color</span>
                    <div class="color-input-container">
                        <input type="color" class="editor-form__input required editor-form__input-color"
                            name="yarn-color-${id}" id="yarn-color-${id}">
                    </div>
                </div>
                <div class="w-10" >
                    <i class="fas fa-trash form-editor__icon" data-remove="yarn"></i>
                </div>
            `;
  };

addValuesToFields = () => {
  // Fill all main fields from data
  for (let i = 0; i < this.count; i++) {
    const rowData = this.data[i] || {};
    const name = rowData.name || "";
    const material = rowData.material || "";
    const yarnId = rowData.yid || "";
    const num = rowData.num || "";
    const color = rowData.bg_color || "";
    const doubleThread = rowData.double_thread || "";

    if (document.querySelector(`#yarn-no-material-${i}`)) {
      document.querySelector(`#yarn-no-material-${i}`).value = material;
      document.querySelector(`#yarn-no-material-${i}`).setAttribute("data-id", yarnId);
    }
    if (document.querySelector(`#yarn-no-${i}`))
      document.querySelector(`#yarn-no-${i}`).value = name;
    if (document.querySelector(`#yarn-num-no-${i}`))
      document.querySelector(`#yarn-num-no-${i}`).value = num;
    if (document.querySelector(`#yarn-color-${i}`)) {
      document.querySelector(`#yarn-color-${i}`).value = color || "#000000";
      document.querySelector(`#yarn-color-${i}`).parentElement.style.backgroundColor = color || "#000";
    }
    if (document.querySelector(`#yarn-num-thread-${i}`))
      document.querySelector(`#yarn-num-thread-${i}`).value = doubleThread;
  }

  // Fill first 10 copy fields (show blanks if no data)
  for (let i = 0; i < 10; i++) {
    const rowData = this.data[i] || {};
    const name = rowData.name || "";
    const material = rowData.material || "";
    const yarnId = rowData.yid || "";
    const num = rowData.num || "";
    const color = rowData.bg_color || "";
    const doubleThread = rowData.double_thread || "";

    if (document.querySelector(`#copy-yarn-no-material-${i}`)) {
      document.querySelector(`#copy-yarn-no-material-${i}`).value = material;
      document.querySelector(`#copy-yarn-no-material-${i}`).setAttribute("data-id", yarnId);
    }
    if (document.querySelector(`#copy-yarn-no-${i}`))
      document.querySelector(`#copy-yarn-no-${i}`).value = name;
    if (document.querySelector(`#copy-yarn-num-no-${i}`))
      document.querySelector(`#copy-yarn-num-no-${i}`).value = num + (doubleThread || "");
    if (document.querySelector(`#copy-yarn-color-${i}`)) {
      document.querySelector(`#copy-yarn-color-${i}`).value = color || "#000000";
      document.querySelector(`#copy-yarn-color-${i}`).parentElement.style.backgroundColor = color || "#000";
    }
  }

  if ((this.data.length === 0 || !this.data[0] || !this.data[0].num) && document.querySelector(`#yarn-num-no-0`)) {
    document.querySelector(`#yarn-num-no-0`).value = "1.00";
  }

};




  removeField = (e) => {
  this.count--;
  const iconContainer = e.target.parentElement.parentElement;
  iconContainer.remove();

  // Only remove a copy field column if we have more than 10
  const copyColumnsCount = document.querySelectorAll('#yarn-container-copy .yarn-row-material > div').length;
  if (copyColumnsCount > 10) {
    this.removeCopyYarnFieldColumn();
  }

  this.renderCopyFields();
};


  renderCopyFields = () => {
    this.removeValuesFromCopyFields();
    const containerElements = this.container.querySelectorAll(".editor-form__subrow");

    // Collect array with position and data
    let indexed = [];
    for (let order = 0; order < containerElements.length; order++) {
      const container = containerElements[order];
      const inputs = container.querySelectorAll("input");
      let value = inputs[2].value.trim(); // "No" field, e.g. "1.01"
      let floatValue = isNaN(parseFloat(value)) ? order : parseFloat(value.replace(",", "."));
      indexed.push({ index: order, floatValue, element: container, inputs });
    }

    // Sort by float value
    indexed.sort((a, b) => a.floatValue - b.floatValue);

    // Fill copy fields in sorted order
    for (let sortedPos = 0; sortedPos < indexed.length; sortedPos++) {
      let { inputs } = indexed[sortedPos];
      for (let k = 0; k < inputs.length; k++) {
        const idArray = inputs[k].id.split("-");
        idArray[idArray.length - 1] = sortedPos; // Use new sorted index
        const newElementId = idArray.join("-");
        const copiedElement = document.querySelector("#copy-" + newElementId);
        if (!copiedElement) continue;
        if (copiedElement.type === "color") {
          copiedElement.parentElement.style.backgroundColor = inputs[k].value;
          copiedElement.value = inputs[k].value;
        } else {
          copiedElement.value = inputs[k].value;
        }
      }
    }

    this.reorderSequinsCopyColumnsToYarnNumbers();

  };


  removeValuesFromCopyFields = () => {
    // prettier-ignore
    const inputFields = this.copyContainer.querySelectorAll("input[type='text']");
    for (const field of inputFields) field.value = "";
    const colorFields = this.copyContainer.querySelectorAll(
      ".color-input-container"
    );
    for (const field of colorFields) field.style.backgroundColor = "#000";
  };

  addField = () => {
  // 1. Find the next available HTML id (always use one higher than any existing)
  let maxId = -1;
  this.container.querySelectorAll("input[id^='yarn-no-material-']").forEach(input => {
    const idNum = parseInt(input.id.replace("yarn-no-material-", ""), 10);
    if (!isNaN(idNum) && idNum > maxId) maxId = idNum;
  });
  const newId = maxId + 1;

  // 2. Find the highest main number used in the "No" fields
  let maxMain = 0;
  this.container.querySelectorAll("input[id^='yarn-num-no-']").forEach(input => {
    let val = (input.value || "").replace(",", ".").trim();
    let match = val.match(/^(\d+)\./);
    if (match) {
      const mainNum = parseInt(match[1], 10);
      if (!isNaN(mainNum) && mainNum > maxMain) maxMain = mainNum;
    }
  });
  let nextNumber = (maxMain + 1) + ".00";

  // 3. Create the new field
  const div = document.createElement("div");
  Object.assign(div, {
    className: "w-100 editor-form__subrow editor-form__subrow--modify relative",
    innerHTML: this.template(newId),
  });
  this.container.appendChild(div);
  customSelect.addScrollEventToObject(div);
  this.addFocusEventsToField(div);

  // 4. Set the new number in the num field
  const numInput = this.container.querySelector(`#yarn-num-no-${newId}`);
  if (numInput) numInput.value = nextNumber;

  // 5. Add new copy field column if going above 10
  const copyColumnsCount = document.querySelectorAll('#yarn-container-copy .yarn-row-material > div').length;
  if (copyColumnsCount <= newId) {
    this.addCopyYarnFieldColumn(newId);
  }

  // 6. Update count and sync copy fields
  this.count = this.container.querySelectorAll('.editor-form__subrow').length;
  this.renderCopyFields();
};





  renderFields = () => {
  for (let id = 0; id < this.count; id++) {
    const div = document.createElement("div");
    Object.assign(div, {
      className: "w-100 editor-form__subrow editor-form__subrow--modify relative",
      innerHTML: this.template(id),
    });
    this.container.appendChild(div);
  }
};


  renderFieldNamesAndIds = () => {
    const inputFields = this.container.querySelectorAll("input");
    // we have three input in every subcontainer
    let id = 0;
    for (let i = 0; i < inputFields.length; i++) {
      const nameParts = inputFields[i].name.split("-");
      const newName = `${nameParts.slice(0, -1).join("-")}-${id}`;
      inputFields[i].name = newName;
      inputFields[i].id = newName;
      if (i !== 0 && (i + 1) % 3 === 0) id++;
    }
    const icons = this.container.querySelectorAll("i");
    for (let i = 1; i <= icons.length; i++) {
      icons[i - 1].setAttribute("data-id", i);
    }
  };

  addFocusEventsToField = (container) => {
    const element = container.querySelector(".editor-form__custom-select");
    element.addEventListener("focus", (e) => {
      customSelect.focusSelect(e);
    });
  };

  doubleThreadInput = () => {
    return `<div><input type="text" class="editor-form__input editor-form__input-double-thread d-none" name="yarn-num-thread-${id}" autocomplete="off" id="yarn-num-thread-${id}"></div>`;
  };

  showDoubleThreadInput = () => {
    this.hideDoubleThread = false;
    document
      .querySelectorAll(".editor-form__double-thread")
      .forEach((input) => {
        input.classList.remove("d-none");
      });
    this.renderCopyFields();
  };

  hideDoubleThreadInput = () => {
    this.hideDoubleThread = true;
    document
      .querySelectorAll(".editor-form__double-thread")
      .forEach((input) => {
        input.classList.add("d-none");
      });
    this.renderCopyFields();
  };

  /* Sets data to this object */
  setData = (data) => {
    if (!data) return;
    this.data = data;
    this.count = data.length;
  };

  static copyDataToForm = (field, value) => {
    const copyYarn = document.querySelector("#copy-" + field.id);
    copyYarn.value = value;
  };

  addCopyYarnFieldColumn = (idx) => {
    // Add material
    let materialRow = document.querySelector("#yarn-container-copy .yarn-row-material");
    let matDiv = document.createElement("div");
    matDiv.className = "border-right border-bottom";
    matDiv.style.flex = "1";
    matDiv.innerHTML = `<input type="text" class="copy-form__input" id="copy-yarn-no-material-${idx}">`;
    materialRow.appendChild(matDiv);

    // Add name
    let nameRow = document.querySelector("#yarn-container-copy .yarn-row-name");
    let nameDiv = document.createElement("div");
    nameDiv.className = "border-right border-bottom";
    nameDiv.style.flex = "1";
    nameDiv.innerHTML = `<input type="text" class="copy-form__input" id="copy-yarn-no-${idx}">`;
    nameRow.appendChild(nameDiv);

    // Add number
    let numRow = document.querySelector("#yarn-container-copy .yarn-row-number");
    let numDiv = document.createElement("div");
    numDiv.className = "border-right border-bottom";
    numDiv.style.flex = "1";
    numDiv.innerHTML = `<input type="text" class="copy-form__input" id="copy-yarn-num-no-${idx}">`;
    numRow.appendChild(numDiv);

    // Add color
    let colorRow = document.querySelector("#yarn-container-copy .yarn-row-color");
    let colorDiv = document.createElement("div");
    colorDiv.className = "border-right border-bottom h-1 color-input-container";
    colorDiv.style.flex = "1";
    colorDiv.innerHTML = `<input type="color" class="copy-form__input copy-form__input-color" id="copy-yarn-color-${idx}">`;
    colorRow.appendChild(colorDiv);
  };

  removeCopyYarnFieldColumn = () => {
    ["material", "name", "number", "color"].forEach(rowType => {
      let row = document.querySelector(`#yarn-container-copy .yarn-row-${rowType}`);
      if (row && row.children.length) row.removeChild(row.lastElementChild);
    });
  };

  reorderSequinsCopyColumnsToYarnNumbers = () => {
  // 1. Get all yarn "No" values in display order (as many as exist)
  const yarnCopyNumFields = document.querySelectorAll('[id^="copy-yarn-num-no-"]');
  const yarnCopyNumbers = Array.from(yarnCopyNumFields).map(input => input.value.trim());

  // 2. Get all sequins "No" values and fields (as many as exist)
  const sequinsNumFields = document.querySelectorAll('[id^="copy-sequins-num-no-"]');
  const sequinsFieldsByIdx = Array.from(sequinsNumFields).map((input, idx) => ({
    idx,
    value: input.value.trim(),
  }));

  // 3. Prepare to track unmatched sequins
  const unmatchedSequins = [];

  // 4. For each sequins field, find yarn column index (or queue as unmatched)
  sequinsFieldsByIdx.forEach(({ idx, value }) => {
    const yarnColIdx = yarnCopyNumbers.indexOf(value);

    if (yarnColIdx !== -1) {
      // Copy all fields: material, name, number, color
      // Material
      let src = document.getElementById(`copy-sequins-no-material-${idx}`);
      let dst = document.getElementById(`copy-sequins-no-material-${yarnColIdx}`);
      if (src && dst) dst.value = src.value;

      // Name
      src = document.getElementById(`copy-sequins-no-${idx}`);
      dst = document.getElementById(`copy-sequins-no-${yarnColIdx}`);
      if (src && dst) dst.value = src.value;

      // Number
      src = document.getElementById(`copy-sequins-num-no-${idx}`);
      dst = document.getElementById(`copy-sequins-num-no-${yarnColIdx}`);
      if (src && dst) dst.value = src.value;

      // Color
      src = document.getElementById(`copy-sequins-color-${idx}`);
      dst = document.getElementById(`copy-sequins-color-${yarnColIdx}`);
      if (src && dst) {
        dst.value = src.value;
        dst.parentElement.style.backgroundColor = src.value;
      }
    } else {
      unmatchedSequins.push(idx);
    }
  });

  // 5. (Optional) Handle unmatched sequins columns: clear or display at end if desired
  // Example: clear their corresponding copy columns
  // unmatchedSequins.forEach(idx => {
  //   ['no-material', 'no', 'num-no', 'color'].forEach(suffix => {
  //     const field = document.getElementById(`copy-sequins-${suffix}-${idx}`);
  //     if (field) field.value = '';
  //     if (suffix === 'color' && field) field.parentElement.style.backgroundColor = '#000';
  //   });
  // });
};



}
